import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthenticationGuard } from "./index";
import { PermissionGuard } from "./permission.guard";

// Guards

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [AuthenticationGuard, PermissionGuard],
})
export class GuardsModule {}
